import { useSelector } from 'react-redux';

import { isAllowed } from '../helpers/auth';
import { Permissions } from '../helpers/permissions';

export default function usePermissions(roleLabel) {
    const currentScopes = useSelector(
        ({ core: { currentScopes }}) => currentScopes
    );
    // If there are no scopes, then authorization is indeterminate.
    if (!currentScopes.length) {
        return null;
    }
    return isAllowed(currentScopes, Permissions(roleLabel));
}
